import * as React from 'react'
import { helperPlaceholderSVG } from '../helpers.mod'

export const breadcrumbs = () => (
  <nav className="breadcrumb text--s">
    <div className="breadcrumb__inner ls-container">
      <ul className="breadcrumb__list">
        <li className="breadcrumb__item">
          <a href="" className="breadcrumb__link">
            <span className="breadcrumb__label">
              Home
            </span>
          </a>
        </li>
        <li className="breadcrumb__item">
          <a href="" className="breadcrumb__link">
            <span className="breadcrumb__label">
              Products
            </span>
          </a>
        </li>
        <li className="breadcrumb__item">
          <a href="" className="breadcrumb__link">
            <span className="breadcrumb__label">
              Doors and portals
            </span>
          </a>
        </li>
      </ul>
    </div>
  </nav>
)

export const expertiseHeader = () => {
  return (
    <header className='hero hero--expertise'>
      <div className="hero__inner ls-container">
        <div className="hero__content">
          <div className="hero__header">
            <span className="hero__label">
              {/* TO DO: add content type */}
              expertise
            </span>
            <h1 className="hero__title title--m">
              We create and improve living space for a growing world population
            </h1>
          </div>
          <div className="hero__footer">
            <div className="hero__clickable">
              <a className="link" href="#">View our products </a>
            </div>
            <div className="hero__clickable">
              <a className="link" href="#">View our products </a>
            </div>
          </div>
        </div>
        <div className="hero__visual">
          <img loading="lazy" src={helperPlaceholderSVG({ shape: { width: 2880, height: 1620, radius: '0', color: '#e8e8e8' }, text: { color: '#1e1e1e', size: '40px', font: 'Open Sans, sans-serif' } })} alt="" className="hero__image" />
        </div>
        <div className="hero__icon"></div>
      </div>
    </header>
  )
}

export const projectHeader = () => {
  return (
    <header className='hero hero--project'>
      <div className="hero__inner ls-container">
        <div className="hero__content">
          <div className="hero__header">
            <span className="hero__label">
              {/* TO DO: add content type */}
              project
            </span>
            <h1 className="hero__title title--m">
            2.300 hectares of new land for Dubai
            </h1>
          </div>
          <div className="hero__footer">
            <div className="hero__clickable">
              <a className="link" href="#">View our project</a>
            </div>
            <div className="hero__clickable">
              <a className="link" href="#">Go back to overview</a>
            </div>
          </div>
        </div>
        <div className="hero__visual">
          <img loading="lazy" src={helperPlaceholderSVG({ shape: { width: 2880, height: 1620, radius: '0', color: '#e8e8e8' }, text: { color: '#1e1e1e', size: '40px', font: 'Open Sans, sans-serif' } })} alt="" className="hero__image" />
        </div>
        <div className="hero__icon">
          <ul className="hero__list icons">
            <li className="icons__column icon">
              <svg className="icon__icon" height="45" width="88">
                <use xlinkHref="#icon--expertise"/>
              </svg>
              <p className="icon__text text--s">136 projects in 44 countries</p>
            </li>
            <li className="icons__column icon">
              <svg className="icon__icon" height="45" width="88">
                <use xlinkHref="#icon--expertise"/>
              </svg>
              <p className="icon__text text--s">150 years of experience as marine contractor</p>
            </li>
            <li className="icons__column icon">
              <svg className="icon__icon" height="45" width="88">
                <use xlinkHref="#icon--expertise"/>
              </svg>
              <p className="icon__text text--s">71 nationalities of ingenious people</p>
            </li>
          </ul>
        </div>
      </div>
    </header>
  )
}

export const genericHeader = () => {
  return (
    <header className='hero hero--generic'>
      <div className="hero__inner ls-container">
        <div className="hero__content">
          <div className="hero__header">
            <span className="hero__label">
              {/* TO DO: add content type */}
              content type
            </span>
            <h1 className="hero__title title--m">
            Sustainable dyke reinforcement: emission-free and innovative through unique collaboration
            </h1>
          </div>
          <div className="hero__footer">
            <div className="hero__clickable">
              <a className="link" href="#">Read our updates</a>
            </div>
            <div className="hero__clickable">
              <a className="link" href="#">Go back to our updates</a>
            </div>
          </div>
        </div>
        <div className="hero__visual">
          <img loading="lazy" src={helperPlaceholderSVG({ shape: { width: 2880, height: 1620, radius: '0', color: '#e8e8e8' }, text: { color: '#1e1e1e', size: '40px', font: 'Open Sans, sans-serif' } })} alt="" className="hero__image" />
        </div>
      </div>
    </header>
  )
}

export const resultsHeader = () => {
  return (
    <header className='hero hero--results'>
      <div className="hero__inner ls-container">
        <div className="hero__content">
          <div className="hero__header">
            <span className="hero__label">
              {/* TO DO: add content type */}
              content type
            </span>
            <h1 className="hero__title title--m">Find the perfect job oppurtunity for you</h1>
          </div>
        </div>
      </div>
    </header>
  )
}

export const detailUpdateHeader = () => {
  return (
    <header className='hero hero--detail'>
      <div className="hero__inner ls-container">
        <div className="hero__content">
          <div className="hero__header">
            <span className="hero__label">
              {/* TO DO: add content type */}
              updates
            </span>
            <h1 className="hero__title title--m">
            Sustainable dyke reinforcement: emission-free and innovative through unique collaboration
            </h1>
          </div>
          <ul className="hero__list tags">
            <li className='tags__item'>
              <a className='tag--m' href="/styleguide">partnership</a>
            </li>
            <li className='tags__item'>
              <a className='tag--m' href="/styleguide">Nibh Egestas</a>
            </li>
          </ul>
        </div>
        <div className="hero__visual">
          <img loading="lazy" src={helperPlaceholderSVG({ shape: { width: 2880, height: 1620, radius: '0', color: '#e8e8e8' }, text: { color: '#1e1e1e', size: '40px', font: 'Open Sans, sans-serif' } })} alt="" className="hero__image" />
        </div>
      </div>
    </header>
  )
}